module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-auth"
  }, [_c('image-bg', {
    attrs: {
      "image": 'bg' + (Math.floor(Math.random() * 7) + 1) + '.jpg'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-login"
  }, [_c('div', {
    staticClass: "logo"
  }, [_vm._v("Wtis")]), _vm._v(" "), _c('div', {
    staticClass: "d-t"
  }, [_c('div', {
    staticClass: "d-r"
  }, [_c('div', {
    staticClass: "d-c left"
  }, [_c('div', {
    staticClass: "timer"
  }, [_c('h1', [_vm._v(_vm._s(_vm.nowTime))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.nowDate))])])]), _vm._v(" "), _c('div', {
    staticClass: "d-c r"
  }, [_c('div', {
    staticClass: "login-tab"
  }, [_c('ul', {
    staticClass: "options"
  }, [_c('li', {
    class: {
      'selected': _vm.selected === 'colaborador'
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "data-class": "simple"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSelected('colaborador')
      }
    }
  }, [_vm._v("Colaborador")])]), _vm._v(" "), _c('li', {
    class: {
      'selected': _vm.selected === 'consultaReboque'
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "data-class": "dev"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSelected('consultaReboque')
      }
    }
  }, [_vm._v("Consulta Reboque")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfloat"
  }), _vm._v(" "), _c('div', {
    staticClass: "hdiv"
  }), _vm._v(" "), _c('div', {
    staticClass: "pcontent"
  }, [(null !== _vm.loginErrorData) ? _c('div', {
    staticClass: "login-errors"
  }, [_c('div', [_vm._v(_vm._s(_vm.loginErrorData))])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "login1"
    }
  }, [_c('Login', {
    attrs: {
      "channel": _vm.selected
    },
    on: {
      "error": _vm.loginError
    }
  })], 1), _vm._v(" "), _vm._m(0)])])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login2"
    }
  }, [_c('form', {
    staticClass: "form-login",
    attrs: {
      "action": "",
      "method": "post",
      "novalidate": ""
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "_csrf_token",
      "value": " csrf_token "
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "reveal1",
    staticStyle: {
      "display": "block",
      "clear": "both",
      "width": "100%",
      "font-family": "Arial, Helvetica, sans-serif",
      "font-size": "11px"
    },
    attrs: {
      "data-sr": "enter wait 0.8s"
    }
  }, [_vm._v("Por favor aguarde")]), _vm._v(" "), _c('label', {
    staticClass: "reveal2",
    staticStyle: {
      "display": "block",
      "clear": "both",
      "width": "100%",
      "margin-top": "-10px",
      "font-family": "Arial, Helvetica, sans-serif",
      "font-size": "11px"
    },
    attrs: {
      "data-sr": "enter wait 2.2s"
    }
  }, [_vm._v("\n                                          app.request.server.get(\"REMOTE_ADDR\") request connection")]), _vm._v(" "), _c('label', {
    staticClass: "reveal3",
    attrs: {
      "for": "username2",
      "data-sr": "enter wait 2.6s"
    }
  }, [_vm._v("Logar\n                                          como:")]), _vm._v(" "), _c('input', {
    staticClass: "input-login username",
    attrs: {
      "type": "text",
      "id": "username2",
      "name": "_username",
      "value": "",
      "placeholder": "",
      "autocomplete": "off",
      "required": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "reveal4"
  }, [_c('label', {
    attrs: {
      "for": "password2"
    }
  }, [_vm._v("Senha:")]), _vm._v(" "), _c('input', {
    staticClass: "input-login password",
    attrs: {
      "type": "password",
      "id": "password2",
      "name": "_password",
      "placeholder": "",
      "required": ""
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "reveal5",
    staticStyle: {
      "display": "block",
      "clear": "both",
      "width": "100%",
      "margin-top": "-10px",
      "font-family": "Arial, Helvetica, sans-serif",
      "font-size": "11px",
      "visibility": "hidden"
    },
    attrs: {
      "data-sr": "enter wait 2.2s"
    }
  }, [_vm._v("Mais um momento por\n                                          favor")]), _vm._v(" "), _c('button', {
    staticClass: "btn-login",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Entrar")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-bottom-left"
  }, [_c('a', {
    staticClass: "recover-pw",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Esqueci meu acesso")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-bottom-right"
  }, [_c('a', {
    staticClass: "sponsored",
    attrs: {
      "href": "https://www.wtis.com.br",
      "target": "_blank"
    }
  }, [_vm._v("Desenvolvido por Wtis")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a08a2dba","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/auth/components/Main.vue
// module id = 1815
// module chunks = 17